import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';

// Global Types
import { AppState } from 'services/types';
import { MyTimesheetEntriesProps } from 'services/myTimesheetEntries/types';

// Global Selectors
import {
    makeSelectMyTimesheetEntryStartTime,
    makeSelectMyTimesheetEntryEndTime
} from 'services/myTimesheetEntries/selectors';

type OwnProps = MyTimesheetEntriesProps;

interface ConnectedProps {
    startTime?: string;
    endTime?: string;
}

type Props = OwnProps & ConnectedProps;

export class MyTimesheetEntryWorkHoursValue extends React.PureComponent<Props> {
    render(): string | null {
        const { startTime, endTime } = this.props;

        if (!startTime || !endTime) {
            return null;
        }

        return `${moment(startTime, 'hh:mm').format('hh:mma')} - ${moment(
            endTime,
            'hh:mm'
        ).format('hh:mma')}`;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    startTime: makeSelectMyTimesheetEntryStartTime(),
    endTime: makeSelectMyTimesheetEntryEndTime()
});

export default connect(mapStateToProps)(MyTimesheetEntryWorkHoursValue);
